import React, {Component} from 'react'
import './BackOfficeNavMenuComponent.css'
import './FrontOfficeNavMenuComponent.css'
import {Nav, NavItem, DropdownButton, NavDropdown, Navbar, MenuItem, Collapse} from 'react-bootstrap'
import {Link, NavLink, Route} from 'react-router-dom'

import HeaderComponent from '../components/HeaderComponent'

import Carrello from '../assets/carrello.png'
import Spunta from '../assets/spunta.png'

const UserAreaLink = ({ label, to, children }) => (
  <Route path={to} children={({ match }) => (
    <li className={match ? 'li-home-list' : 'li-list'}>
      <Link className={'clear-link'} to={to}>{children}</Link>
    </li>
  )} />
)

const UserAreaLinkMobile = ({ label, to, children, onLiClick }) => (
  <Route path={to} children={({ match }) => (
    <li onClick={() => onLiClick()} className={(match ? 'li-home-list' : 'li-list') + ' mobile-nav-link'}>
      <Link style={{textAlign: 'left'}} className={'clear-link'} to={to}>{children}</Link>
    </li>
  )} />
)

export default class FrontOfficeNavMenuComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      mobileMenuVisible: false
    }
  }

  render () {
    return (<div>
      <Navbar className="nav-user" style={{marginBottom: 0}}>

        <button type="button"
          onClick={() => this.setState({mobileMenuVisible: !this.state.mobileMenuVisible})}
          className="navbar-toggle collapsed navbar-btn visible-sm visible-xs"
          data-toggle="collapse"
          aria-expanded="false"
          aria-controls="navbar">
          <span className="sr-only">Mostra/Nascondi Menù</span>
          <span className="icon-bar">{}</span>
          <span className="icon-bar">{}</span>
          <span className="icon-bar">{}</span>
        </button>

        <div className="visible-sm hidden-md hidden-lg visible-xs">
          <Collapse in={this.state.mobileMenuVisible}>
            {/* <ul className="nav navuser-list-div nav-pills">
                                <UserAreaLink to={"/user-area/profile"}>HOME</UserAreaLink>
                                <UserAreaLink to={"/user-area/marks"}>CONTRASSEGNI</UserAreaLink>
                                <UserAreaLink to={"/user-area/vehicles"}>VEICOLI</UserAreaLink>
                                <UserAreaLink to={"/user-area/park-tickets"}>ABBONAMENTI</UserAreaLink>
                                <NavLink className="nav-card-id" to={'/user-area/cart'}><img className="logo-nav2" src={Carrello} /></NavLink>
                            </ul> */}
            <div className="nav navuserl-list-div">
              <UserAreaLinkMobile onLiClick={() => this.setState({mobileMenuVisible: false})} to={'/user-area/profile'}>HOME</UserAreaLinkMobile>
              <UserAreaLinkMobile onLiClick={() => this.setState({mobileMenuVisible: false})} to={'/user-area/marks'}>CONTRASSEGNI</UserAreaLinkMobile>
              <UserAreaLinkMobile onLiClick={() => this.setState({mobileMenuVisible: false})} to={'/user-area/vehicles'}>VEICOLI</UserAreaLinkMobile>
              <UserAreaLinkMobile onLiClick={() => this.setState({mobileMenuVisible: false})} to={'/user-area/park-tickets'}>ABBONAMENTI</UserAreaLinkMobile>
              <UserAreaLinkMobile onLiClick={() => this.setState({mobileMenuVisible: false})} to={'/user-area/waiting-lists'}>PRENOTAZIONI</UserAreaLinkMobile>
              <UserAreaLinkMobile onLiClick={() => this.setState({mobileMenuVisible: false})} to={'/user-area/order-history'}>ACQUISTI</UserAreaLinkMobile>
              <UserAreaLinkMobile onLiClick={() => this.setState({mobileMenuVisible: false})} to={'/user-area/cart'}>CARRELLO</UserAreaLinkMobile>
              <li onClick={() => this.setState({mobileMenuVisible: false})} className="mobile-nav-link li-list">
                <a style={{textAlign: 'left'}} className="clear-link" onClick={this.props.onLogoutClick}>LOGOUT</a>
              </li>
            </div>
          </Collapse>
        </div>

        <div className="hidden-sm visible-md visible-lg hidden-xs">
          <div className="row">
            <div className="col-md-8" style={{marginRight: 63}}>
              <ul className="nav navuser-list-div nav-pills">
                <UserAreaLink to={'/user-area/profile'}>HOME</UserAreaLink>
                <UserAreaLink to={'/user-area/marks'}>CONTRASSEGNI</UserAreaLink>
                <UserAreaLink to={'/user-area/vehicles'}>VEICOLI</UserAreaLink>
                <UserAreaLink to={'/user-area/park-tickets'}>ABBONAMENTI</UserAreaLink>
                <UserAreaLink to={'/user-area/waiting-lists'}>PRENOTAZIONI</UserAreaLink>
                <UserAreaLink to={'/user-area/order-history'}>ACQUISTI</UserAreaLink>
              </ul>
            </div>
            <div className="col-md-3">
              <div className="col-personalized-user-nav1" style={{display: 'flex'}}>
                <DropdownButton bsStyle="default" noCaret className="dropdown-nav-no-caret" eventKey={2} title={<div><img className="logo-nav1" src={Spunta} />
                  {this.props.user.firstName.toUpperCase() + ' ' + this.props.user.lastName.toUpperCase()}</div>}>
                  <MenuItem onClick={this.props.onLogoutClick} eventKey={2.1}><span className="glyphicon glyphicon-log-out" /> Logout</MenuItem>
                </DropdownButton>
                <div className="col-personalized-user-nav2">
                  <NavLink className="nav-card-id" to={'/user-area/cart'}><img className="logo-nav2" src={Carrello} /></NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*<div className="visible-sm hidden-md hidden-lg hidden-xs">
          <div className="row">
            <div className="col-sm-12" style={{display: '-webkit-inline-box'}}>
              <ul className="nav navuser-list-div nav-pills">
                <UserAreaLink to={'/user-area/profile'}>HOME</UserAreaLink>
                <UserAreaLink to={'/user-area/marks'}>CONTRASSEGNI</UserAreaLink>
                <UserAreaLink to={'/user-area/vehicles'}>VEICOLI</UserAreaLink>
                <UserAreaLink to={'/user-area/park-tickets'}>ABBONAMENTI</UserAreaLink>
                <UserAreaLink to={'/user-area/waiting-lists'}>PRENOTAZIONI</UserAreaLink>
                <UserAreaLink to={'/user-area/order-history'}>ACQUISTI</UserAreaLink>
              </ul>
              <div className="col-personalized-user-nav1" style={{display: 'flex'}}>
                <DropdownButton bsStyle="default" noCaret className="dropdown-nav-no-caret" eventKey={2} title={<div><img className="logo-nav1" src={Spunta} />
                  {this.props.user.firstName.toUpperCase() + ' ' + this.props.user.lastName.toUpperCase()}</div>}>
                  <MenuItem onClick={this.props.onLogoutClick} eventKey={2.1}><span className="glyphicon glyphicon-log-out" /> Logout</MenuItem>
                </DropdownButton>
                <div className="col-personalized-user-nav2">
                  <NavLink className="nav-card-id" to={'/user-area/cart'}><img className="logo-nav2" src={Carrello} /></NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>*/}

      </Navbar>
      <HeaderComponent />
    </div>
    )
  }
}

{ /* <div className="col-md-4">
 <div className="col-md-10">
 <DropdownButton bsStyle="default" noCaret className="dropdown-nav-no-caret" eventKey={2} title={<div><img className="logo-nav1" src={Spunta}/>
 {this.props.user.firstName.toUpperCase() + " " + this.props.user.lastName.toUpperCase()}</div>}>
 <MenuItem onClick={this.props.onLogoutClick} eventKey={2.1}><span className="glyphicon glyphicon-log-out"></span> Logout</MenuItem>
 </DropdownButton>
 <div className="col-md-2">
 <NavLink className="nav-card-id" to={'/user-area/cart'}><img className="logo-nav2" src={Carrello} /></NavLink>
 </div>
 </div>
 </div> */ }



// WEBPACK FOOTER //
// ./src/components/FrontOfficeNavMenuComponent.js